export const defineFontSettings = (small, standard) => ({ small, standard });
